import { useEffect } from 'react';

export const useFavicon = (faviconUrl) => {
    useEffect(() => {
        if (!faviconUrl) return;

        // Find existing favicon links
        const existingLinks = document.querySelectorAll('link[rel*="icon"]');
        
        // Create new favicon link
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = faviconUrl;
        
        // Remove existing favicon links
        existingLinks.forEach(link => {
            link.remove();
        });
        
        // Add new favicon
        document.head.appendChild(link);
        
        // Cleanup function
        return () => {
            // Don't remove on cleanup as we want to keep the favicon
        };
    }, [faviconUrl]);
};

export default useFavicon;